import { AnimationObserver } from '@relay/client';

new AnimationObserver({ rootMargin: '0px 0px -20% 0px' });
